import { motion } from 'framer-motion';
import softwareImage from "../../assets/explore-services/software.png";
import aiImage from "../../assets/explore-services/ai.png";
import designImage from "../../assets/explore-services/design.png";

import { CursorArrowRaysIcon, PaintBrushIcon, CodeBracketIcon } from '@heroicons/react/24/outline'

const services = [
  {
    title: 'Website & Mobile App Development',
    eyebrow: 'Software',
    description: 'From sleek marketing websites to scalable mobile and web apps, we build polished digital products that work beautifully across every screen.',
    image: softwareImage,
    icon: CodeBracketIcon,
  },
  {
    title: 'Custom AI Integration & Data Analysis',
    eyebrow: 'AI Systems',
    description: 'We add practical intelligence to your workflows with chatbots, automation, recommendations, analytics, and AI-powered product features.',
    image: aiImage,
    icon: CursorArrowRaysIcon,
  },
  {
    title: 'Branding, UI/UX & Graphic Design',
    eyebrow: 'Design',
    description: 'Stand out with thoughtful identities, clean interfaces, memorable visuals, and user experiences that feel easy from the first click.',
    image: designImage,
    icon: PaintBrushIcon,
  },
];

export default function ExploreServices() {
  return (
    <div className="relative py-24 transition-colors duration-300 dark:bg-dark-bg sm:py-32" id="explore-services">
      <div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
        <div className="max-w-3xl">
          <h2 className="text-base/7 font-medium text-primary dark:text-secondary">Grow smarter & faster</h2>
          <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-950 dark:text-white sm:text-5xl">
            Everything you need to launch a better digital product.
          </p>
          <p className="mt-5 text-base leading-7 text-gray-600 dark:text-gray-400">
            Strategy, design, engineering, and AI support in one focused team.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:mt-16 lg:grid-cols-3">
          {services.map((service, index) => {
            const Icon = service.icon;

            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                className="landing-service-card group relative overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-white/10 dark:bg-white/10"
              >
                <div className="absolute left-6 top-6 z-10 flex h-11 w-11 items-center justify-center rounded-lg bg-primary text-secondary">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <div className="relative flex h-full flex-col">
                  <div className="relative flex h-80 items-center justify-center">
                    <img
                      alt=""
                      src={service.image}
                      className="h-2/3 object-contain transition duration-500 group-hover:scale-110"
                    />
                  </div>
                  <div className="relative z-10 p-8 pt-0">
                    <h3 className="w-fit rounded-lg bg-primary px-4 py-1 text-sm font-medium text-secondary-light">{service.eyebrow}</h3>
                    <p className="mt-4 text-xl font-semibold tracking-tight text-gray-950 dark:text-white">{service.title}</p>
                    <p className="mt-3 max-w-lg text-sm leading-6 text-gray-600 dark:text-gray-400">{service.description}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  )
}
